import { DocumentViewerModule } from './../shared/document-viewer/document-viewer.module';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClinicalRecordListComponent } from './clinical-record-list/clinical-record-list.component';

@NgModule({
  declarations: [
    ClinicalRecordListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DocumentViewerModule
  ],
  exports: [
    ClinicalRecordListComponent
  ]
})
export class ClinicalRecordModule { }
